import {
  Box,
  Link,
  VStack,
  HStack,
  Button,
  Divider,
  Spinner,
  Text,
} from '@chakra-ui/react';
import Papa from 'papaparse';
import React, { useState, useEffect } from 'react';

import { CSVPreview } from './CSVPreview';

type Props = { downloads: { filename: string; url: string }[] };
export const DownloadLinkPanel = ({ downloads }: Props) => {
  const [data, setData] = useState<any>(null);
  const [showTable, setShowTable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileType, setFileType] = useState<string | null>(null);

  useEffect(() => {
    setShowTable(false);
  }, [downloads]);

  const handleShowPreview = async ({
    filename,
    url,
  }: {
    filename: string;
    url: string;
  }) => {
    const extension = filename.split('.').pop() || '';
    setIsLoading(true);
    const response = await fetch(url);
    const text = await response.text();

    const setJsonData = (jsonData: object) => {
      setFileType('json');
      setData(JSON.stringify(jsonData, null, 4));
    };

    if (extension === 'csv') {
      setFileType(extension);
      const parsedData = Papa.parse(text, { header: true, dynamicTyping: true })
        .data;
      setData(parsedData.slice(0, 10));
    } else if (extension === 'json') {
      try {
        setJsonData(JSON.parse(text));
      } catch (e) {
        setJsonData({ error: e });
      }
    } else {
      setJsonData({ error: `Unsupported file type: ${extension}` });
    }

    setShowTable(true);
    setIsLoading(false);
  };

  return (
    <Box
      width="100%"
      resize="both"
      overflow="auto"
      height={500}
      border="1px solid #ccc"
    >
      {downloads.map((download) => {
        return (
          <VStack align="start" key={`download-${download.url}`}>
            {/* Left-align here */}
            <HStack spacing={4}>
              {/* Switch positions of Button and Link */}
              <Button onClick={() => handleShowPreview(download)}>
                Show Preview
              </Button>
              <Link href={download.url} download={download.filename}>
                {download.filename}
              </Link>
            </HStack>
          </VStack>
        );
      })}{' '}
      <Divider />
      {isLoading ? (
        <HStack spacing={2}>
          <Spinner />
          <Text>Loading...</Text>
        </HStack>
      ) : (
        showTable &&
        (fileType === 'csv' ? (
          <CSVPreview data={data || []} />
        ) : (
          <Box as="pre" overflowX="scroll" whiteSpace="pre-wrap">
            {data}
          </Box>
        ))
      )}
    </Box>
  );
};
